import { transport } from 'config/transport';

export function callApiGetAllOptionalDuThu(congDoanId, gradeId) {
    return transport.get(`/mamnon/${congDoanId}/thuhocsinh/${gradeId}/duthu/duthutuchon`);
}
